export const CALCULATOR = 'CALCULATOR';
export const EDITOR = 'EDITOR';
export const UI_SETTINGS = 'UI_SETTINGS';
